interface NavAttributes {
  [propName: string]: any;
}
interface NavWrapper {
  attributes: NavAttributes;
  element: string;
}
interface NavBadge {
  text: string;
  variant: string;
}
interface NavLabel {
  class?: string;
  variant: string;
}

export interface NavData {
  name?: string;
  url?: string;
  icon?: string;
  badge?: NavBadge;
  title?: boolean;
  children?: NavData[];
  variant?: string;
  attributes?: NavAttributes;
  divider?: boolean;
  class?: string;
  label?: NavLabel;
  wrapper?: NavWrapper;
}

localStorage.removeItem('month');
localStorage.removeItem('year');

export const navItems= {
  TH:[
    {
      title: true,
      name: 'หัวข้อกราฟและรายงาน'
    },
    {
      name: 'ข้อมูลสรุป',
      url: '/dashboard',
      icon: 'far fa-calendar-alt'
    },
    {
      name: 'กราฟข้อมูลสรุป',
      url: '/chart',
      icon: 'fas fa-chart-pie'
    },
    {
      name:"รายงาน/เอกสาร",
      url:"/report",
      icon:"fas fa-book",
      children:[
      {
        name:"ใบทวงหนี้",
        url:"/report_inform",
        icon:"fas fa-file"
      },
      {
        name:"ใบแจ้งหนี้",
        url:"/report_invoice",
        icon:"fas fa-file-alt"
      },
      {
        name:"การยกเลิกใบแจ้งหนี้",
        url:"/report_invoice_cancel",
        icon:"fas fa-file-alt"
      },
      {
        name:"ใบเสร็จรับเงิน",
        url:"/report_bill",
        icon:"fas fa-wallet"
      },
      {
        name:"การยกเลิกใบเสร็จรับเงิน",
        url:"/report_bill_cancel",
        icon:"fas fa-wallet"
      },
      {
        name:"การใช้งานระบบ",
        url:"/report_logs",
        icon:"far fa-address-card"
      }
      ]
    }
    ,
    {
      title: true,
      name: 'หัวข้อข้อมูลทั่วไป'
    },
    {
      name:"ข้อมูลทั่วไป",
      url:"/customer",
      icon:"fas fa-thumbtack",
      children:[
        {
        name:"คำนำหน้า",
        url:"/prefix",
        icon:"fas fa-user"
      },
      {
        name:"ชนิดที่อยู่",
        url:"/place_type",
        icon:"fas fa-home"
      },
      {
        name:"ชนิดค่าธรรมเนียม",
        url:"/fee_type",
        icon:"fas fa-trash-alt"
      },
      {
        name:"ประเภทการชำระ",
        url:"/payment_type",
        icon:"fas fa-tags"
      }
      ]
    },
    {
      name:"ผู้เสียค่าธรรมเนียม",
      url:"/customer",
      icon:"fas fa-user-friends"
    },
    {
      name:"ค่าธรรมเนียม",
      url:"/fee",
      icon:"fas fa-comment-dollar"
    },
    {
      name:"แผนที่",
      url:"/maps_vector",
      icon:"fas fa-map-marker-alt"
    },
    {
      name:"ชำระค่าธรรมเนียม",
      url:"/paybill",
      icon:"fas fa-file-alt",
    },
    {
      title: true,
      name: 'หัวข้อข้อมูลเอกสาร'
    },
    {
      name:"นำเข้าเอกสาร",
      url:"/inform",
      icon:"fas fa-book",
      children:[
        {
          name:"นำเข้าใบแจ้งหนี้",
          url:"/import_invoice",
          icon:"fas fa-file",
        }
        ,{
          name:"นำเข้าใบเสร็จรับเงิน",
          url:"/import_bill",
          icon:"fas fa-wallet",
        }
      ]
    },
    {
      title: true,
      name: 'หัวข้อข้อมูลพนักงาน'
    }
    ,
    {
      name:"ข้อมูลพนักงาน",
      url:"/user_position",
      icon:"fas fa-user",
      children: [
        {
          name:"ตำแหน่งของพนักงาน",
          url:"/user_position",
          icon:"fas fa-map-marked"
        },
        {
          name:"โซนของพนักงาน",
          url:"/user_zone",
          icon:"fas fa-address-card"
        },
        {
          name:"เคลียร์ยอดเงินสด",
          url:"/clear_payment",
          icon:"fas fa-cut"
        }
      ]
    },
    {
      title: true,
      name: 'หัวข้อคำร้องและการร้องเรียน'
    },
    {
      name:"คำร้องจากภาคสนาม",
      url:"/customer_request",
      icon:"fas fa-plus"
    },
    {
      name:"คำร้องทั่วไป",
      url:"/request_general",
      icon:"fas fa-book"
    }
  ],
  EN:[
    {
      title: true,
      name: 'Dashboard & Report'
    },
    {
      name: 'Dashboard',
      url: '/dashboard',
      icon: 'far fa-file-alt'
    },
    {
      name: 'Chart',
      url: '/chart',
      icon: 'icon-chart'
    },
    {
      name:"Report/Document",
      url:"/report",
      icon:"fas fa-user",
      children:[
        {
        name:"Report Inform",
        url:"/report_inform",
        icon:"fas fa-user"
      },
      {
        name:"Report Invoice",
        url:"/report_invoice",
        icon:"fas fa-home"
      },
      {
        name:"Report Invoice (Cancel)",
        url:"/report_invoice_cancel",
        icon:"fas fa-home"
      },
      {
        name:"Report Bill",
        url:"/report_bill",
        icon:"fas fa-dollar-sign"
      },
      {
        name:"Report Bill (Cancel)",
        url:"/report_bill_cancel",
        icon:"fas fa-dollar-sign"
      },
      {
        name:"History Logs",
        url:"/report_logs",
        icon:"fas fa-comments-dollar"
      }
      ]
    }
    ,
    {
      title: true,
      name: 'Genaral information'
    },
    {
      name:"Genaral",
      url:"/customer",
      icon:"fas fa-user",
      children:[
        {
        name:"Prefix",
        url:"/prefix",
        icon:"fas fa-user"
      },
      {
        name:"Place Type",
        url:"/place_type",
        icon:"fas fa-home"
      },
      {
        name:"Fee Type",
        url:"/fee_type",
        icon:"fas fa-dollar-sign"
      },
      {
        name:"Payment Type",
        url:"/payment_type",
        icon:"fas fa-comments-dollar"
      }
      ]
    }
    ,
    {
      name:"Customer",
      url:"/customer",
      icon:"fas fa-user-friends"
    },
    {
      name:"Fee",
      url:"/fee",
      icon:"fas fa-money-check-alt"
    },
    {
      name:"Map",
      url:"/maps_vector",
      icon:"fas fa-search"
    },
    {
      name:"Paybill",
      url:"/paybill",
      icon:"fas fa-scroll",
    }
    ,
    {
      title: true,
      name: 'Invoice & Bill'
    },
    {
      name:"Import Documents",
      url:"/inform",
      icon:"fas fa-paste",
      children:[
        {
          name:"Import Invoice",
          url:"/import_invoice",
          icon:"fas fa-file",
        }
        ,{
          name:"Import Bill",
          url:"/import_bill",
          icon:"fas fa-wallet",
        }
      ]
    },
    {
      title: true,
      name: 'User & Zone'
    }
    ,
    {
      name:"Employee information",
      url:"/user_position",
      icon:"fas fa-map-marked",
      children: [
        {
          name:"Employee Position",
          url:"/user_position",
          icon:"fas fa-map-marked"
        },
        {
          name:"Employee Zone",
          url:"/user_zone",
          icon:"fas fa-address-card"
        },
        {
          name:"Clear Payment",
          url:"/clear_payment",
          icon:"fas fa-cut"
        }
      ]
    },
    {
      title: true,
      name: 'Petition & Request'
    },
    {
      name:"Petition",
      url:"/customer_request",
      icon:"fas fa-book"
    },
    {
      name:"Request General",
      url:"/request_general",
      icon:"fas fa-book"
    }
]
}
